import { render, staticRenderFns } from "./DocGroup.vue?vue&type=template&id=09904b8c&"
import script from "./DocGroup.vue?vue&type=script&lang=js&"
export * from "./DocGroup.vue?vue&type=script&lang=js&"
import style0 from "./DocGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports